import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { getImageUploadsError, IMAGE_UPLOAD_ACCEPT, IMAGE_UPLOAD_HELP } from "../../../utils/imageUpload";

function TourGallery({ gallery, setGallery }) {

    // Handle file upload
    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        const imageError = getImageUploadsError(files);
        if (imageError) {
            toast.error(imageError);
            e.target.value = "";
            return;
        }

        // Max 4 validation
        if (files.length + gallery.length > 4) {
            toast.error("Maximum 3 images allowed");
            return;
        }

        // Create preview URLs (FIX for black image issue)
        const newFiles = files.map((file) => ({
            file,
            preview: URL.createObjectURL(file),
        }));

        setGallery([...gallery, ...newFiles]);
    };

    // Remove image
    const handleRemove = (index) => {
        const updated = gallery.filter((_, i) => i !== index);
        setGallery(updated);
    };

    // Cleanup (IMPORTANT - avoid memory leak)
    useEffect(() => {
        return () => {
            gallery.forEach((item) => {
                if (item.preview) {
                    URL.revokeObjectURL(item.preview);
                }
            });
        };
    }, [gallery]);

    return (
        <div className="mt-4 p-4 border rounded-lg bg-white shadow-sm">
            {/* Header */}
            <div className="flex justify-between items-center mb-2">
                <h3 className="text-lg font-semibold">Tour Gallery</h3>
                <span className="text-sm text-gray-500">
                    {gallery.length}/3 images
                </span>
            </div>

            {/* Upload Box */}
            <div
                style={{
                    border: "1px dashed #ccc",
                    padding: "20px",
                    textAlign: "center",
                    borderRadius: "8px",
                    cursor: "pointer",
                    background: "#fafafa",
                }}
            >
                <input
                    type="file"
                    multiple
                    accept={IMAGE_UPLOAD_ACCEPT}
                    onChange={handleFileChange}
                    style={{ marginBottom: "10px" }}
                />

                <p style={{ fontSize: "14px", color: "#666" }}>
                    Drag & drop images here <br /> or click to browse
                </p>
            </div>

            {/* Preview Section */}
            <div className="flex gap-3 mt-4 flex-wrap">
                {gallery.map((item, index) => (
                    <div
                        key={index}
                        style={{
                            position: "relative",
                            width: "120px",
                            height: "90px",
                        }}
                    >
                        <img
                            src={item.preview} // ✅ FIXED (no more black images)
                            alt="preview"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: "8px",
                                border: "1px solid #ddd",
                            }}
                        />

                        {/* Remove Button */}
                        <button
                            onClick={() => handleRemove(index)}
                            style={{
                                position: "absolute",
                                top: "-8px",
                                right: "-8px",
                                background: "red",
                                color: "#fff",
                                border: "none",
                                borderRadius: "50%",
                                width: "22px",
                                height: "22px",
                                cursor: "pointer",
                            }}
                        >
                            ✕
                        </button>
                    </div>
                ))}
            </div>

            {/* Footer */}
            <p className="text-xs text-gray-500 mt-2">
                Upload up to 4 high-quality images. {IMAGE_UPLOAD_HELP}
            </p>
        </div>
    );
}

export default TourGallery;
